import React, { useEffect } from "react";
import { ReservationsDetailData } from "../../Api";
import { useAuthContext } from "../../context/auth";
import api from "../../lib/api";
import cn from "../../utils/cn";

function Start() {
  const [reservations, setReservations] =
    React.useState<ReservationsDetailData>([]);
  const { circuitProgram, basicProgram, sendStartTimer, sendSetStep, classId } =
    useAuthContext();
  useEffect(() => {
    const getReservations = async () => {
      if (classId) {
        api.fits.reservationsDetail(classId).then((res) => {
          setReservations(res.data);
        });
      }
    };
    getReservations();
    const interval = setInterval(() => {
      getReservations();
    }, 5000);
    return () => clearInterval(interval);
  }, [classId]);

  const program = circuitProgram ?? basicProgram;
  return (
    <div className="bg-bg flex flex-col w-full h-full">
      <div className="w-full flex-1 flex flex-col justify-center items-center">
        <h1 className="text-[120px] text-white mt-[300px]">{program?.name}</h1>
        <div className="flex-1" />
        <button
          className="rounded-[32px] text-[100px] text-black py-4 px-[160px] flex justify-center items-center mb-[200px] bg-gradient-beige-horizontal"
          onClick={() => {
            sendStartTimer();
          }}
        >
          GO!
        </button>

        {classId && (
          <div className="mt-4 flex w-full py-[60px] px-[60px] gap-y-[30px] gap-x-[60px] flex-wrap bg-[#ffffff1f] h-[630px]">
            {reservations
              .sort((a, b) =>
                a.status === "RESERVED" ? 1 : b.status === "RESERVED" ? -1 : 0
              )
              .map((reservation, index) => (
                <div
                  key={index}
                  className={cn(
                    "flex items-center gap-[20px]",
                    reservation.status === "RESERVED" && "opacity-20"
                  )}
                >
                  <img
                    src={
                      reservation.user?.profileImageUrl ||
                      "/defaultProfileImage.png"
                    }
                    alt="profile"
                    className="w-[60px] h-[60px] rounded-full"
                  />
                  <h2 className="text-[30px] text-white">
                    {reservation.user?.name}
                  </h2>
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Start;
